import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DialogComponentKey, DialogComponentInstance } from '@interfaces/dialog';
import { GatedDocumentConfig } from '@interfaces/documents';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  public component$: Subject<Type<DialogComponentInstance>> = new Subject();
  public extras$: BehaviorSubject<GatedDocumentConfig | null> = new BehaviorSubject(null);

  public showDialog(key: DialogComponentKey, extras?: GatedDocumentConfig): void {
    this.extras$.next(extras ?? null);
    this.importComponent(key).then(instance => this.component$.next(instance));
  }

  private async importComponent(key: DialogComponentKey): Promise<Type<DialogComponentInstance> | null> {
    let module: Record<string, Type<DialogComponentInstance>>;

    switch (key) {
      case 'SEARCH':
        module = await import('@components/common/_dialogs/search-dialog/search-dialog.component');
        break;
      case 'GATED_FORM':
        module = await import('@components/common/_dialogs/gated-form-dialog/gated-form-dialog.component');
        break;
      case 'NEWSLETTER':
        module = await import(
          '@components/common/_dialogs/newsletter-subscription-dialog/newsletter-subscription-dialog.component'
        );
        break;
        case 'WEBINAR':
          module = await import(
            '@components/common/_dialogs/webinar-dialog/webinar-dialog.component'
          );
        break;
    }

    if (module) {
      return Object.values(module)[0];
    }

    return null;
  }
}
